<template>
  <div>
    <PageTitle :title="$t('global.certificates')">
      <template #actions>
        <Btn variant="primaryOutline" class="mr-2" @click="importCert">{{
          $t("global.import-certificate")
        }}</Btn>
        <router-link :to="{ name: 'certificate-add' }" class="button-router-link">
          <Btn variant="primary">{{ $t("global.order-certificate") }}</Btn>
        </router-link>
      </template>
    </PageTitle>
    <CertificatesTable :certificates="certificates" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Btn from "@/components/display/Btn";
import CertificateImportModal from "@/components/smart/modals/CertificateImport";
import CertificatesTable from "@/components/smart/tables/CertificatesTable";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "CertificatesList",
  components: {
    Btn,
    CertificatesTable,
    PageTitle,
  },
  setup() {
    const certificates = computed(() => store.state.certificates);

    const importCert = () => {
      store.dispatch("modals/open", {
        template: CertificateImportModal,
      });
    };

    onMounted(() => {
      store.dispatch("certificates/getList");
    });
    return {
      certificates,
      importCert,
    };
  },
};
</script>
